import { useAuth0 } from "@auth0/auth0-react";
import { Navigate, Link, useSearchParams } from "react-router-dom";
import { ArrowLeft, ArrowRight, Check } from "lucide-react";

export function LoginPage() {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  const [searchParams] = useSearchParams();
  const requestedReturnTo = searchParams.get("returnTo");
  const returnTo =
    requestedReturnTo?.startsWith("/") && !requestedReturnTo.startsWith("//")
      ? requestedReturnTo
      : "/tipping/dashboard";

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={returnTo} replace />;
  }

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background px-5 py-12">
      <div className="public-grid absolute inset-0 opacity-30" />
      <Link to="/" className="absolute left-5 top-5 z-10 inline-flex items-center gap-2 text-sm font-bold text-white/50 hover:text-white sm:left-8 sm:top-8">
        <ArrowLeft className="h-4 w-4" /> Back to Tackle Four
      </Link>
      <div className="relative grid w-full max-w-4xl overflow-hidden border border-white/[0.1] bg-navy-900 shadow-2xl md:grid-cols-[0.9fr_1.1fr]">
        <div className="bg-primary px-7 py-10 sm:px-10 md:flex md:flex-col md:justify-between md:py-12">
          <h1 className="font-display text-4xl font-black uppercase tracking-wider text-white">
            Tackle<span className="text-navy-950">Four</span>
          </h1>
          <div className="mt-16 md:mt-24">
            <p className="font-data text-[10px] font-bold uppercase tracking-[0.2em] text-navy-950/60">Your tipping season</p>
            <h2 className="font-display mt-3 text-4xl font-black uppercase leading-none text-white">Every call. Every point. One place.</h2>
          </div>
        </div>
        <div className="px-7 py-10 sm:px-12 md:py-14">
          <p className="font-data text-[10px] font-bold uppercase tracking-[0.2em] text-ice">Members</p>
          <h2 className="font-display mt-3 text-4xl font-black uppercase">Sign in to tip</h2>
          <p className="mt-4 text-sm leading-6 text-white/45">Enter your picks, join private competitions and follow every point across the NRL and AFL season.</p>
          <div className="mt-7 space-y-3 text-sm text-white/60">
            {["Private and public competitions", "Margins, bonuses and live scoring", "Personal history, badges and stats"].map((item) => (
              <div key={item} className="flex items-center gap-3"><Check className="h-4 w-4 text-correct" /> {item}</div>
            ))}
          </div>
          <button
            onClick={() => loginWithRedirect({ appState: { returnTo } })}
            className="mt-9 flex w-full items-center justify-center gap-2 rounded-md bg-primary px-6 py-3.5 text-sm font-extrabold text-white transition-colors hover:bg-coral-600"
          >
            Continue with email <ArrowRight className="h-4 w-4" />
          </button>
          <p className="mt-4 text-center text-[11px] leading-5 text-white/30">New here? We’ll create your account after you sign in.</p>
        </div>
      </div>
    </div>
  );
}
